/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_TriggerInputs */

const cs_workflow_trigger = /** @type {(inputs: Workflow_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spouštěče`)
};

const en_workflow_trigger = /** @type {(inputs: Workflow_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triggers`)
};

/**
* | output |
* | --- |
* | "Triggers" |
*
* @param {Workflow_TriggerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_trigger = /** @type {((inputs?: Workflow_TriggerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_TriggerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_trigger(inputs)
	return cs_workflow_trigger(inputs)
});